module.exports = __webpack_public_path__ + "static/smalloffice-a19f44f5b7fc96367ccb789293b7931f.png";